import { markRaw, shallowRef } from 'vue'
import type { Component } from 'vue'

type HeaderComponent = Component | null
type HeaderProps = Record<string, unknown> | null

const headerActionsComponent = shallowRef<HeaderComponent>(null)
const headerActionsProps = shallowRef<HeaderProps>(null)

export function usePageHeader() {
    const setHeaderActions = (
        component: Component,
        props?: Record<string, unknown>
    ) => {
        const rawComp = markRaw(component)
        if (headerActionsComponent.value !== rawComp) {
            headerActionsComponent.value = rawComp
        }
        headerActionsProps.value = props ?? {}
    }

    const clearHeaderActions = () => {
        headerActionsComponent.value = null
        headerActionsProps.value = null
    }

    return {
        headerActionsComponent,
        headerActionsProps,
        setHeaderActions,
        clearHeaderActions,
    }
}